import SystemValueList from "../../../../components/SystemValue/SystemValueList";

const COLUMNS = [
  {
    header: "Currency",
    render: (item) =>
      item.currency?.code
        ? `${item.currency.code} - ${item.currency.name}`
        : "—",
  },
];

const CurrencyList = ({ userCurrencies, onEdit, onDelete }) => (
  <SystemValueList
    items={userCurrencies}
    columns={COLUMNS}
    onEdit={onEdit}
    onDelete={onDelete}
    emptyMessage="No currencies added yet."
  />
);

export default CurrencyList;
